<template>
  <div class="container">
    <HomeNavigationDrawer
      @toggle-filters="toggleFilters"
      @apply-filters="applyFilters"
      @update-filters="updateFilters"
      @has-active-filters="checkForActiveFilters"
      @get-folder-content="setTableParameters"
      :tableFolder="tableFolder"
      :drawer="drawer"
      :show-input-search-folder="showInputSearchFolder"
      :systemFolders="
        $route.query.view === 'MIRROR_HISTORIC'
          ? systemFoldersMirrorHistoric
          : systemFolders
      "
      :homeViewMode="homeViewMode"
      :loading-folders="loadingFolders"
      @update-filter="findSystemFoldersTree"
    >
      <template v-slot:buttons>
        <Dropdown
          openIcon="mdi-chevron-down"
          iconColor="graydark"
          tooltip="Ações"
        >
          <template v-slot:header>
            <div class="dropdown-header">Ações disponíveis</div>
          </template>
          <template v-slot:content>
            <div class="dropdown-content">
              <v-list>
                <v-list-item ripple v-if="isAdminUser" @click="admin">
                  <v-icon left>mdi-account-settings-outline</v-icon>
                  Admin
                </v-list-item>
                <v-list-item
                  ripple
                  @click="refreshPermissions"
                  :disabled="!refreshPermissionsEnabled"
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Atualizar permissões
                </v-list-item>
                <v-list-item ripple @click="logout">
                  <v-icon left>mdi-power</v-icon>
                  Logout
                </v-list-item>
              </v-list>
            </div>
          </template>
        </Dropdown>
      </template>

      <template v-slot:exibition>
        <div class="line">
          <v-text-field
            color="graydark"
            value="Cards"
            readonly
            outlined
            hide-details
            prepend-inner-icon="mdi-view-grid-outline"
          >
          </v-text-field>
          <v-switch inset color="primary"></v-switch>
        </div>

        <div class="line">
          <v-text-field
            color="graydark"
            value="Tabela"
            readonly
            outlined
            hide-details
            prepend-inner-icon="mdi-table"
          >
          </v-text-field>
          <v-switch inset color="primary"></v-switch>
        </div>
      </template>

      <template v-slot:content>
        <div class="line">
          <v-text-field
            color="graydark"
            value="Pautas"
            readonly
            outlined
            hide-details
            prepend-inner-icon="mdi-lightbulb-outline"
          >
          </v-text-field>
          <v-switch inset color="primary"></v-switch>
        </div>

        <div class="line">
          <v-text-field
            color="graydark"
            value="Contatos"
            readonly
            outlined
            hide-details
            prepend-inner-icon="mdi-account-circle-outline"
          >
          </v-text-field>
          <v-switch inset color="primary"></v-switch>
        </div>
      </template>
    </HomeNavigationDrawer>

    <AppBar
      class="main"
      :class="{ 'side-panel': drawer }"
      :sidePanel="drawer"
      :height="appBarHeight"
    >
      <template v-slot:open-side-pannel>
        <v-btn class="filter" icon @click="toggleFilters()">
          <v-icon>mdi-notification-clear-all</v-icon>
          <div v-if="hasSelectedFilter" class="badge"></div>
        </v-btn>
      </template>
      <template v-slot:title>
        <HeaderTitle :homeViewMode="homeViewMode" class="hidden-md-and-down" />
      </template>
      <template v-slot:toggles>
        <HeaderToggles
          :homeViewMode="homeViewMode"
          @changeViewMode="handleViewToggle"
        />
      </template>

      <template v-slot:avatar>
        <div class="avatar"></div>
      </template>

      <template v-slot:search>
        <div
          v-if="[viewModes.CARD, viewModes.CONTACT].includes(homeViewMode)"
          class="flex-column filter-wrapper"
        >
          <SearchInput
            v-model="query"
            @clickAppend="handleSearch"
            @keydownEnter="handleSearch"
            @clickClear="handleSearch"
          />
          <div class="d-flex justify-end" v-if="$vuetify.breakpoint.lgAndUp">
            <HomeSearchMenu
              :value="filters"
              @apply-filters="applyFilters"
              @update-filters="updateSearchMenuFilters"
              @has-active-filters="checkForActiveFilters"
            />
          </div>
        </div>
      </template>
    </AppBar>

    <template v-if="shouldShowCards">
      <Error
        v-if="noFolderAccessCard"
        :textTitle="
          'Tão <span>vazio</span> por aqui... <br/>Onde estão as <span>retrancas</span>?!'
        "
        :textDescription="
          'Não encontramos nenhuma gaveta de retrancas vinculada ao seu usuário no iNews.'
        "
        :imageTitle="'bored'"
        showButtons
        class="no-folder-access"
        :class="{
          'side-panel': drawer,
        }"
      />
      <Error
        v-else-if="shouldShowCards_NotFoundOrError"
        :textTitle="
          'Nosso panda <span>detetive</span><br/> <span>não encontrou</span> resultados.'
        "
        :textDescription="'Tente pesquisar por outros termos :)'"
        :imageTitle="'detective'"
        showButtons
        class="empty-search"
        :class="{
          'side-panel': drawer,
        }"
      />
      <CardList
        v-else
        @setSelectedStory="setSelectedHistoricStory"
        :news="news"
        :isLoading="isFetchingNews"
        :homeContentMode="homeContentMode"
        @loadMoreNews="loadNews"
        :class="{ 'side-panel': drawer }"
      />
    </template>
    <template v-else-if="shouldShowTable">
      <Error
        v-if="shouldShowNeedFolderSelectionError"
        :textTitle="
          'Nosso <span>panda detetive</span><br/> precisa de uma <span>gaveta</span> para encontrar resultados.'
        "
        :textDescription="
          `Por favor, clique na opção NAVEGAR POR GAVETAS ${
            this.$vuetify.breakpoint.xs
              ? 'no menu hamburguer ao lado do panda'
              : 'no painel à esquerda'
          } e escolha ao menos uma opção.`
        "
        :imageTitle="'detective'"
        class="empty-search"
        :class="{
          'side-panel': drawer,
        }"
      />
      <Error
        v-else-if="noFolderAccessTable"
        :textTitle="
          'Tão <span>vazio</span> por aqui... <br/>Onde estão as <span>retrancas</span>?!'
        "
        :textDescription="
          'Você não possui permissão de leitura para a gaveta selecionada.'
        "
        :imageTitle="'bored'"
        class="empty-search"
        :class="{
          'side-panel': drawer,
        }"
      />
      <Error
        v-else-if="shouldShowFolder_NotFoundOrError"
        :textTitle="
          'Tão <span>vazio</span> por aqui... <br/>Onde estão as <span>retrancas</span>?!'
        "
        :textDescription="'A gaveta selecionada ainda não possui retrancas.'"
        :imageTitle="'detective'"
        :showButtons="writePermission"
        class="empty-search"
        :class="{
          'side-panel': drawer,
        }"
        :btn-text="
          this.homeViewMode === viewModes.TABLE ? 'Criar retranca' : undefined
        "
        @click="handleClickNotFoundOrError"
      />
      <StoryTable
        v-else
        :folderNews="folderNews"
        :fieldMapping="fieldMapping"
        :loadingTable="isFetchingNews"
        :isFetchingFields="isFetchingFields"
        :reorderPermission="reorderPermission"
        :writePermission="writePermission"
        :snackbarBox="snackbarBox"
        :feedbackMessage="feedbackMessage"
        @newStory="newStory"
        @setSelectedStory="setSelectedStory"
        @reorderNews="reorderNews"
        :class="{ 'side-panel': drawer }"
      />
    </template>
    <template v-else-if="shouldShowMirror">
      <MirrorPreviewWrapper :class="{ 'side-panel': drawer }" />
    </template>
    <template v-else-if="shouldShowMirrorHistoric">
      <MirrorHistoric :class="{ 'side-panel': drawer }" />
    </template>
    <template>
      <v-app-bar
        app
        grow
        bottom
        hide-on-scroll
        class="bottom-navigation"
        :class="{ 'force-show': isPageAtBottom }"
      >
        <v-btn
          :class="{ active: homeViewMode === viewModes.CARD }"
          @click.stop="handleViewToggle(viewModes.CARD)"
        >
          <span>Histórico</span>
          <v-icon>mdi-lightbulb-outline</v-icon>
        </v-btn>

        <v-btn
          :class="{ active: homeViewMode === viewModes.TABLE }"
          @click.stop="handleViewToggle(viewModes.TABLE)"
        >
          <span>Tempo Real</span>
          <v-icon>mdi-table</v-icon>
        </v-btn>

        <v-btn
          :class="{ active: homeViewMode === viewModes.CONTACT }"
          @click.stop="handleViewToggle(viewModes.CONTACT)"
        >
          <span>Contatos</span>
          <v-icon>mdi-account-circle-outline</v-icon>
        </v-btn>

        <v-btn
          :class="{ active: homeViewMode === viewModes.MIRROR }"
          @click.stop="handleViewToggle(viewModes.MIRROR)"
        >
          <span>Espelhos</span>
          <v-icon>mdi-timetable</v-icon>
        </v-btn>
      </v-app-bar>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppBar from '@/components/shared/AppBar.vue';
import HeaderToggles from '@/components/home/HeaderToggles.vue';
import HeaderTitle from '@/components/home/HeaderTitle.vue';
import SearchInput from '@/components/home/SearchInput.vue';
import HomeSearchMenu from '@/components/home/HomeSearchMenu/index.vue';
import CardList from '@/components/stories/CardList.vue';
import StoryTable from '@/components/stories/StoryTable.vue';
import MirrorPreviewWrapper from '@/components/mirrorPreview/MirrorPreviewWrapper.vue';
import MirrorHistoric from '@/components/mirrors/MirrorHistoric.vue';
import Error from '@/components/shared/Error.vue';
import Dropdown from '@/components/shared/Dropdown.vue';
import HomeNavigationDrawer from '@/components/home/HomeNavigationDrawer/index.vue';
import { categories, actions } from '@/constants/analytics.js';
import { storyModes, contentModes, viewModes } from '@/utils/mappers.js';
import { sortOrder } from '../utils/mappers';
import { debounce } from 'lodash';

export default {
  name: 'home',
  components: {
    AppBar,
    CardList,
    Dropdown,
    StoryTable,
    MirrorPreviewWrapper, //eslint-disable-line
    Error,
    HomeNavigationDrawer,
    HeaderToggles,
    HeaderTitle,
    SearchInput,
    HomeSearchMenu,
    MirrorHistoric,
  },
  data() {
    return {
      sortOrder,
      selectedStory: null,
      query: undefined,
      filters: {
        order: sortOrder.DESC,
        fromDate: undefined,
        toDate: undefined,
        author: undefined,
      },
      cardFolders: [],
      tableFolder: [],
      hasSelectedFilter: false,
      loadingFolders: false,
      activeTab: 1,
      homeViewMode: viewModes.CARD,
      homeContentMode: 0,
      isPageAtBottom: false,
      storyModes,
      viewModes,
      contentModes,
      drawer: this.getDrawerInitialCondition(),
      refreshPermissionsEnabled: true,
    };
  },
  watch: {
    $route: 'onRouteChange',
    homeViewMode: {
      immediate: true,
      handler(newValue) {
        if (viewModes.MIRROR === newValue)
          window.location = `${process.env.VUE_APP_URL_NEW_NH}/mirrors`;

        if (viewModes.TABLE === newValue)
          window.location = `${process.env.VUE_APP_URL_NEW_NH}/agenda-folders`;
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('news/reset');
    this.hideSnackbar();
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.query = to.query.q || '';
    next();
  },
  created() {
    this.loadFiltersFromRoute();
    // update news or folder stories
    if ([viewModes.CARD, viewModes.CONTACT].includes(this.homeViewMode)) {
      this.loadNews();
    } else if (viewModes.TABLE === this.homeViewMode) {
      this.loadFolderContent();
    }
    this.loadSystemFoldersTree();
    this.loadSystemFoldersMirrorHistoricTree();
    this.checkForAdmin();

    document.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapState({
      news: state => state.news.news,
      folderNews: state => state.news.folderNews,
      fieldMapping: state => state.news.fieldMapping,
      feedbackMessage: state => state.news.feedbackMessage,
      isFetchingNews: state => state.news.isFetchingNews,
      isFetchingFields: state => state.news.isFetchingFields,
      fetchNewsError: state => state.news.fetchNewsError,
      currentUser: state => state.user.currentUser,
      isAdminUser: state => state.user.isAdminUser,
      pautaClient: state => state.pautaClient,
      noFolderAccessCard: state => state.news.noFolderAccessCard,
      noFolderAccessTable: state => state.news.noFolderAccessTable,
      reorderPermission: state => state.news.reorderPermission,
      writePermission: state => state.news.writePermission,
      systemFolders: state => state.news.systemFolders,
      systemFoldersMirrorHistoric: state =>
        state.mirror.systemFoldersMirrorHistoric,
      snackbarBox: state => state.news.snackbarBox,
    }),
    showInputSearchFolder() {
      return [viewModes.CARD, viewModes.TABLE, viewModes.CONTACT].includes(
        this.homeViewMode,
      );
    },
    shouldShowCards() {
      return [viewModes.CARD, viewModes.CONTACT].includes(this.homeViewMode);
    },

    shouldShowTable() {
      return this.homeViewMode === viewModes.TABLE;
    },

    shouldShowMirror() {
      return (
        this.homeViewMode === viewModes.MIRROR &&
        parseInt(process.env.VUE_APP_MIRROR_ENABLED)
      );
    },
    shouldShowMirrorHistoric() {
      return this.homeViewMode === viewModes.MIRROR_HISTORIC;
    },
    shouldShowCards_NotFoundOrError() {
      return (
        this.fetchNewsError ||
        (this.news.length === 0 &&
          !this.isFetchingNews &&
          !this.noFolderAccessCard)
      );
    },

    shouldShowFolder_NotFoundOrError() {
      return (
        this.fetchNewsError ||
        (this.folderNews.length === 0 &&
          !this.isFetchingNews &&
          !this.noFolderAccessTable)
      );
    },

    shouldShowNeedFolderSelectionError() {
      return (
        this.homeViewMode === viewModes.TABLE && this.tableFolder.length === 0
      );
    },

    appBarHeight() {
      return [this.viewModes.CARD, this.viewModes.CONTACT].includes(
        this.homeViewMode,
      )
        ? '170px'
        : '88px';
    },
  },
  methods: {
    /**
     * Called when the query parameter changes a.k.a. when
     * the user submits a new search
     */
    onRouteChange() {
      // clean up news and paging because loadNews
      // appends news to the current news
      const folderInQuery = this.$route.query.folder;
      if (folderInQuery && this.$vuetify.breakpoint.smAndDown) {
        window.location = `${process.env.VUE_APP_URL_NEW_NH}/agenda-folders`;
      }

      this.loadFiltersFromRoute();
      if ([viewModes.CARD, viewModes.CONTACT].includes(this.homeViewMode)) {
        this.$store.dispatch('news/reset');
        this.loadNews();
      } else if (viewModes.TABLE === this.homeViewMode) {
        this.loadFolderContent();
      }
    },
    handleClickNotFoundOrError() {
      if (this.homeViewMode === viewModes.TABLE) {
        const [place, ...rest] = this.$route.query.folder.split('.');
        const path = rest.join('.');
        this.newStory({ place, path }, 0);
      } else this.$router.push('/');
    },

    loadFiltersFromRoute() {
      this.homeViewMode = this.$route.query.view
        ? viewModes[this.$route.query.view.toUpperCase()]
        : viewModes.CARD;
      this.homeContentMode = Number(this.homeViewMode === viewModes.CONTACT);
      this.query = this.$route.query.q;

      this.filters.fromDate = this.$route.query.fromDate;
      this.filters.toDate = this.$route.query.toDate;
      this.filters.author = this.$route.query.author;
      if (this.homeViewMode === viewModes.TABLE) {
        this.tableFolder = this.$route.query.folder
          ? [this.$route.query.folder]
          : [];
      } else {
        this.cardFolders = this.$route.query.folders
          ? [].concat(this.$route.query.folders)
          : [];
      }
    },
    // handleChangeOrder(order) {
    //   this.filters.order = order;
    //   this.setCardParameters();
    // },
    shouldShowDesktop() {
      return (
        this.$vuetify.breakpoint.smAndUp ||
        !parseInt(process.env.VUE_APP_MIRROR_ENABLED)
      );
    },
    emptyTable() {
      return this.folderNews.length < 1;
    },
    newStory(story, index) {
      const place = story.place;
      const folder = story.path;
      this.$router.push({
        name: 'storyCreation',
        params: { place: place, folder: folder },
        query: { index },
      });
    },

    setSelectedHistoricStory(story) {
      this.$store.dispatch('news/setStoryMode', storyModes.VIEW);
      if (this.homeContentMode === contentModes.CONTACT)
        this.$store.dispatch('analyticsEvent', {
          category: categories.contacts,
          action: actions.contactCardClicked,
          label: `id - ${story.story_id} / title - ${story.data.title}`,
        });
      this.$router.push({
        path: `/storage/story/${story.story_id}`,
        query: { content: this.homeContentMode ? 'contact' : 'story' },
      });
    },

    setSelectedStory(story) {
      this.$store.dispatch('news/setStoryMode', storyModes.VIEW);
      if (this.homeContentMode === contentModes.CONTACT)
        this.$store.dispatch('analyticsEvent', {
          category: categories.contacts,
          action: actions.contactCardClicked,
          label: `id - ${story.story_id} / title - ${story.data.title}`,
        });
      this.$router.push({
        path: `/story/${story.story_id}`,
        query: { content: this.homeContentMode ? 'contact' : 'story' },
      });
    },
    findSystemFoldersTree: debounce(async function(filter = {}) {
      this.loadSystemFoldersTree(filter);
    }, 2000),

    async loadSystemFoldersTree(filter = {}) {
      this.loadingFolders = true;
      await this.$store.dispatch('news/getSystemFoldersTree', {
        filter,
      });
      this.loadingFolders = false;
    },
    loadSystemFoldersMirrorHistoricTree() {
      this.$store.dispatch('mirror/getSystemFoldersHistoricMirrorTree');
    },
    checkForAdmin() {
      this.$store.dispatch('checkIfAdmin');
    },
    setTableParameters(folder = null) {
      const query = Object();
      for (const prop in this.$route.query) {
        if (this.$route.query.hasOwnProperty(prop)) {
          query[prop] = this.$route.query[prop];
        }
      }
      if (folder) {
        query.folder = folder[0];
      }
      this.$router.replace({
        query: query,
      });
    },
    loadFolderContent() {
      if (this.tableFolder.length > 0) {
        this.$store.dispatch('news/getFolderContent', this.tableFolder[0]);
      }
    },
    loadNews() {
      this.$store.dispatch('news/getNews', {
        query: this.query,
        order: this.filters.order,
        fromDate: this.filters.fromDate,
        toDate: this.filters.toDate,
        author: this.filters.author,
        folders: this.cardFolders,
        contact: Boolean(this.homeContentMode),
      });
    },
    handleViewToggle(mode) {
      this.homeViewMode = mode;
      if (viewModes.MIRROR === mode) {
        this.$store.dispatch('analyticsEvent', {
          category: categories.mirror,
          action: actions.mirrorButtonClicked,
        });

        window.location = `${process.env.VUE_APP_URL_NEW_NH}/mirrors`;
      } else {
        switch (mode) {
          case viewModes.CARD:
            this.homeContentMode = contentModes.STORY;
            break;

          case viewModes.CONTACT:
            this.homeContentMode = contentModes.CONTACT;
            this.$store.dispatch('analyticsEvent', {
              category: categories.contacts,
              action: actions.contactsButtonClicked,
            });
            break;

          case viewModes.TABLE:
            window.location = `${process.env.VUE_APP_URL_NEW_NH}/agenda-folders`;

            this.homeContentMode = contentModes.STORY;
            this.$store.dispatch('analyticsEvent', {
              category: categories.table,
              action: actions.tableButtonClicked,
            });

            break;

          case viewModes.MIRROR:
            this.$store.dispatch('analyticsEvent', {
              category: categories.mirror,
              action: actions.mirrorButtonClicked,
            });
            break;

          case viewModes.MIRROR_HISTORIC:
            this.$store.dispatch('analyticsEvent', {
              category: categories.historic_mirror,
              action: actions.mirrorButtonClicked,
            });
            break;

          default:
            break;
        }
        this.setCardParameters();
      }
    },
    handleSearch() {
      this.setCardParameters();
    },
    handleScroll() {
      this.isPageAtBottom =
        window.innerHeight + window.pageYOffset >= document.body.offsetHeight;
    },
    resetSearch() {
      this.query = '';
      this.handleSearch();
    },
    setCardParameters() {
      // updates the query
      if (!this.isCardQueryUnchanged()) {
        this.$router.replace({
          query: {
            view: this.homeViewMode,
            content: this.homeContentMode ? 'contact' : 'story',
            q: this.query,
            fromDate: this.filters.fromDate,
            toDate: this.filters.toDate,
            author: this.filters.author,
            folders: this.cardFolders,
            place: this.place,
            order: this.filters.order,
          },
        });
      }
    },
    toggleFilters(filters) {
      this.drawer = !this.drawer;
      if (this.homeViewMode !== viewModes.TABLE) {
        this.updateFilters(filters);
      }
    },
    admin() {
      this.$router.push('/admin');
    },
    async refreshPermissions() {
      try {
        this.refreshPermissionsEnabled = false;
        await this.$store.dispatch('forcePermissionsRefresh');
      } finally {
        this.refreshPermissionsEnabled = true;
      }
    },
    logout() {
      this.$store.dispatch('logout');
    },
    applyFilters() {
      this.setCardParameters();
      this.sendFiltersAnalytics();
    },
    updateSearchMenuFilters(filters) {
      if (filters) {
        this.filters.author = filters.author;
        this.filters.fromDate = filters.fromDate;
        this.filters.toDate = filters.toDate;
        this.filters.order = filters.order;
      }
    },

    updateFilters(filters) {
      if (filters) {
        this.filters.author = filters.author;
        this.filters.fromDate = filters.fromDate;
        this.filters.toDate = filters.toDate;

        this.cardFolders = filters.cardFolders;
        this.tableFolder = filters.tableFolder;
        this.place = filters.place;
      }
    },
    isCardQueryUnchanged() {
      const currentView = this.$route.query.view
        ? this.$route.query.view.toUpperCase()
        : '';
      return (
        this.homeViewMode === currentView &&
        this.homeContentMode ===
          Number(this.$route.query.content === 'contact') &&
        this.query === this.$route.query.q &&
        this.filters.order === this.$route.order &&
        this.filters.fromDate === this.$route.query.fromDate &&
        this.filters.toDate === this.$route.query.toDate &&
        this.filters.author === this.$route.query.author &&
        this.place === this.$route.query.place &&
        JSON.stringify(this.cardFolders) ===
          JSON.stringify(this.$route.query.folders)
      );
    },
    checkForActiveFilters(hasActiveFilter) {
      this.hasSelectedFilter = hasActiveFilter;
    },
    getDrawerInitialCondition() {
      return !!this.$vuetify.breakpoint.lgAndUp;
    },
    reorderNews(newOrder) {
      this.$store.dispatch('news/reorderStories', newOrder);
    },
    hideSnackbar() {
      this.$store.dispatch('news/snackbarTrigger', false);
    },
    sendFiltersAnalytics() {
      if (this.cardFolders.length > 0)
        this.$store.dispatch('analyticsEvent', {
          category: categories.filter,
          action: actions.filterFolder,
          label: this.cardFolders,
        });
      if (this.filters.fromDate)
        this.$store.dispatch('analyticsEvent', {
          category: categories.filter,
          action: actions.filterFromDate,
          label: this.filters.fromDate,
        });
      if (this.filters.toDate)
        this.$store.dispatch('analyticsEvent', {
          category: categories.filter,
          action: actions.filterToDate,
          label: this.filters.toDate,
        });
      if (this.filters.author)
        this.$store.dispatch('analyticsEvent', {
          category: categories.filter,
          action: actions.filterAuthor,
          label: this.filters.author,
        });
    },
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/inputs.scss';

.main {
  ::v-deep .header-box {
    background-color: transparent;
    box-shadow: none;
  }

  .filter-wrapper {
    width: 100%;
  }
}

.badge {
  align-self: start;
  background: $color-primary;
  border-radius: 6px;
  height: 8px;
  width: 8px;
}

.bottom-navigation {
  display: none;
  z-index: 1;
  width: 100%;
  padding: 0 !important;
  box-shadow: 0 -2px 16px rgba($color-black, 0.16);

  @include for-size(desktop-down) {
    display: flex;
    animation: fadeInUp 0.6s ease-in-out;
  }

  &.force-show {
    transform: translateY(0) !important;
  }

  ::v-deep .v-toolbar__content {
    display: flex;
    flex: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100% !important;
    padding: 0;

    .v-btn {
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
      font-style: italic;
      font-size: 0.72em !important;
      margin: 0 !important;
      flex: 1;
      height: 100%;
      border-radius: 0;
      background-color: $color-white !important;

      .v-btn__content {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column-reverse;

        .v-icon {
          margin: 0;
          font-size: 2em !important;
          color: $color-black-24 !important;
        }
        span {
          color: $color-black-40 !important;
        }
      }

      &.active {
        &.v-btn {
          background-color: $color-white !important;

          &::before {
            display: none;
          }

          .v-btn__content {
            .v-icon,
            span {
              color: $color-primary !important;
            }
          }
        }
      }
    }
  }
}
</style>
